// ToDo: vereinen? general: { ... } --> main: general + {}
const DEFAULT_MAP_OPTIONS = {
    gestureHandling: 'greedy',
    zoomControl: false,
    mapTypeControl: true,
    streetViewControl: false,
    panControl: true,
    rotateControl: false,   // Googles Control aus — custom Tilt/Rotate-Modul (tiltRotateControl.js)
    fullscreenControl: false
};

export const MAP_OPTIONS = {
    main: DEFAULT_MAP_OPTIONS,
    gallery: DEFAULT_MAP_OPTIONS
    // Weitere Modi hinzufügen
}